export default __webpack_public_path__ + "static/media/R.6ad4d47e.svg";